import React, { useEffect, useRef, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Container from "../Container/Container";
import "./Chat.scss";
import ChatList from "../ChatList/ChatList";
import ChatRequest from "../../request/ChatRequest";
import ChatMsgHelper from "./ChatMsgHelper";
import { isNotFileAllowed, urlFormatHelper } from "../../helper/helpers";
import { ButtonIcon, DialogBox, MessageInput } from "global-components-library";
import {
  getMsgList,
  setCloseConversation,
  setMessage,
} from "../../redux/conversationDucks";
import { useDispatch, useSelector } from "react-redux";
import { useError } from "../../helper/hooks";
import { useTranslation } from "react-i18next";

const Chat = (props) => {
  const { t } = useTranslation(["media-viewer"]);
  const [currentMsg, setCurrentMsg] = useState("");
  const [writing, setWriting] = useState(0);
  const [isDialogOpen, setDialogOpen] = useState(false);

  const alertTimer = useRef(null);
  const logout = useRef(null);
  const interval = useRef(null);

  const inputRef = useRef();
  const dispatch = useDispatch();
  const conversationList = useSelector(getMsgList);
  const [error, showError, toggleError] = useError();

  useEffect(() => {
    interval.current = setInterval(() => {
      Promise.resolve(ChatRequest.ListenMsg(writing, props.session)).then(
        (xml) => {
          try {
            if (props.agentId === -1) {
              let value = ChatMsgHelper.getSessionOnline(xml);
              value && props.setAgentData(value.id, value.name);
            } else {
              let value = xml.children[0].children[0].attributes.value.value;
              switch (value) {
                case "1":
                  let response = ChatMsgHelper.getMsgResponse(xml);
                  if (response && response.message) {
                    if (!response.isWarning) {
                      onMsgRecived(response.message);
                    } else {
                      setDialogOpen(true);
                    }
                  }

                  break;
                case "3":
                  props.showSurvey();
                  break;
                default:
                  break;
              }
            }
          } catch (e) {
            console.log("Error de entrada de mensajes", e);
          }
        }
      );
    }, 1000);
    if (props.welcomemessage && conversationList.length < 1) {
      dispatch(
        setMessage({
          msg: props.welcomemessage,
          position: "left",
          hour: ChatMsgHelper.getCurrentHour(),
          agentName: props.agentName,
        })
      );
    }
    return () => (clearInterval(interval.current))
  }, []);

  const endSession = () => {
    dispatch(setCloseConversation());
    clearTimmers();
    props.logout();
  };

  const clearTimmers = () => {
    alertTimer.current = null;
    logout.current = null;
    clearInterval(interval.current);
  };

  const onMsgRecived = (msg) => {
    let isMedia =  msg.toString().split('|')[1] === 'image';
    let message = msg.toString().split("\\n");
    let htmlmessage = "";
    for (let index = 0; index < message.length - 1; index++) {
      htmlmessage += message[index] + "\n";
    }
    htmlmessage += message[message.length - 1];
    htmlmessage = htmlmessage.split("|");
    dispatch(
      setMessage({
        msg: isMedia ? urlFormatHelper(htmlmessage[0]) : htmlmessage[0],
        position: "left",
        hour: ChatMsgHelper.getCurrentHour(),
        agentName: props.agentName,
        messageType: htmlmessage[1],
      })
    );
  };

  const onMsgSend = () => {
    let newMsg = currentMsg.trim();
    if (newMsg !== "" && newMsg.length) {
      Promise.resolve(
        ChatRequest.SendMsg(newMsg, props.session, "Text")
      ).then();
      dispatch(
        setMessage({
          msg: newMsg,
          position: "right",
          hour: ChatMsgHelper.getCurrentHour(),
          messageType: "text",
        })
      );
      setCurrentMsg("");
    }
  };

  const onCancel = () => {
    alertTimer.current = null;
  }

  const showMoreInfo = () => {
    props.onMoreOptionsChange();
    props.onMsgList(conversationList);
  };

  const onAttachFile = (e) => {
    let filesAdded = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    if (Object.values(filesAdded).filter((f) => isNotFileAllowed(f)).length > 0) {
      showError(filesAdded.length > 1 ? t('attachErrorTitleMultiple') : t('attachErrorTitleSingle'), t('attachErrorMessage'));
      return;
    }
    if (
      Object.values(filesAdded).filter((f) => f.size / 1000000 > 16).length > 0
    ) {
      showError(
        filesAdded.length > 1 ? t('attachErrorTitleMultiple') : t('attachErrorTitleSingle'),
        filesAdded.length > 1 ? t('attachErrorMultiple') : t('attachErrorSingle')
      );
      return;
    }
    if (filesAdded.length > props.maxImgToSend ) {
      filesAdded = { ...Object.values(filesAdded).slice(0,props.maxImgToSend ) };
    }
    Object.values(filesAdded).forEach((f) => {
      Promise.resolve(
        ChatRequest.onUploadAttachment(
          props.agentId,
          props.chatId,
          f.name,
          f
        )
      )
        .then((response) => response.json())
        .then((url) => onMsgMultimediaSend(url));
    });
    inputRef.current.value = '';
  };

  const onMsgMultimediaSend = (url) => {
    if (url.length > 0) {
      Promise.resolve(ChatRequest.SendMsg(url, props.session, "Image")).then();
      dispatch(
        setMessage({
          msg: urlFormatHelper(url),
          position: "right",
          hour: ChatMsgHelper.getCurrentHour(),
          messageType: "image",
        })
      );
      setCurrentMsg("");
    }
  };
  const closeConversationHandler = () => {
    dispatch(setCloseConversation());
    props.closeConversation();
  };

  return (
    <div className="chat-container">
      <Header
        minimize={props.minimize}
        closeConversation={closeConversationHandler}
        isShowBtnClose={true}
      />

      <Container>
        <div className="chat-body">
          <ChatList
            msgList={conversationList ? conversationList : []}
            agentName={props.agentName}
            agentId={props.agentId}
          />
          <div className={`chat-controls ${currentMsg && 'active-btn'}`}>
            <ButtonIcon icon="world-globe" onClick={showMoreInfo} />
            <ButtonIcon
              icon="clip-right"
              onClick={() => {
                inputRef.current.click();
              }}
            />
            <MessageInput
              value={currentMsg}
              onChange={(v) => setCurrentMsg(v)}
              onEnter={onMsgSend}
              disabled={props.agentId === -1}
              onFocus={() => {
                setWriting(1);
                clearTimeout(logout.current);
                clearTimeout(alertTimer.current);
              }}
              onBlur={() => {
                let time = props.timeOut * 500;
                alertTimer.current = setTimeout(() => {
                  clearTimeout(logout.current);
                  logout.current = setTimeout(endSession, time);
                }, time);
                setWriting(0);
              }}
              placeholder={"Escribe un mensaje"}
            />
            <ButtonIcon icon="send" onClick={onMsgSend} disabled={!currentMsg}/>
            <input
              ref={inputRef}
              type="file"
              multiple={true}
              onChange={onAttachFile}
              className="chat-controls-input"
            />
          </div>
        </div>
      </Container>
      <Footer />
      <DialogBox {...error} toggle={toggleError} accept={"Cerrar"} />
      <DialogBox
        show={isDialogOpen}
        toggle={() => setDialogOpen(!isDialogOpen)}
        onAccept={closeConversationHandler}
        onCancel={onCancel}
        title={'Ha pasado algún tiempo sin escribir'}
        content={'¿Desea terminar la conversación?'}
        accept={'Aceptar'}
        cancel={'Cancelar'}
      />
    </div>
  );
};

export default Chat;
